<template>
  <div>
    <default>
    </default>
  </div>
</template>

<script>
import TopMenu from '../layouts/admin/components/topMenu.vue';
import Default from "@/layouts/admin/default.vue";

export default {
  name: "admin",
  components: {Default, TopMenu},
  data() {
    return {
    }
  }, methods: {

  }, mounted() {

  }
}
</script>

<style scoped>

</style>